import Vue from 'vue';
import Vuex from 'vuex';
import Vuetify from '../plugins/vuetify';
import i18n from '../i18n';
import countries from '@/assets/countries';


Vue.use( Vuex );

export default new Vuex.Store( {
    state: {
        event: null,
        frame: null,
        form: null,
        room: null,
        docCheckLogin: null,
        frameLoading: true,
        eventLoading: false,
        formLoading: false,
        roomLoading: false,
        sponsorsLoading: false,
        posterLoading: false,
        foyerLoading: false,
        docCheckLoginLoading: false,
        chatOffset: 0,
        countries: countries,
    },
    mutations: {
        setEvent ( state, event )
        {
            state.event = Object.assign( {}, event );
        },
        setFrame ( state, frame )
        {
            state.frame = Object.assign( {}, frame );
        },
        setForm ( state, form )
        {
            state.form = Object.assign( {}, form );
        },
        setDocCheckLogin ( state, docCheckLogin )
        {
            state.docCheckLogin = Object.assign( {}, docCheckLogin );
        },
        setRoom ( state, room )
        {
            state.room = Object.assign( {}, room );
        },
        setChatOffset ( state, chatOffset )
        {
            state.chatOffset = chatOffset;
        },
        setEventLoading ( state, loading )
        {
            state.eventLoading = loading;
        },
        setFormLoading ( state, loading )
        {
            state.formLoading = loading;
        },
        setDocCheckLoginLoading ( state, loading )
        {
            state.docCheckLoginLoading = loading;
        },
        setFrameLoading ( state, loading )
        {
            state.frameLoading = loading;
        },
        setRoomLoading ( state, loading )
        {
            state.roomLoading = loading;
        },
        setSponsorsLoading ( state, loading )
        {
            state.sponsorsLoading = loading;
        },
        setPosterLoading ( state, loading )
        {
            state.posterLoading = loading;
        },
        setFoyerLoading ( state, loading )
        {
            state.foyerLoading = loading;
        },
    },
    actions: {
        updateEvent ( { commit }, event )
        {
            commit( 'setEvent', event );
        },
        updateFrame ( { commit, state }, frame )
        {
            commit( 'setFrame', frame );
            i18n.locale = frame.language;
            Vue.prototype.moment.locale( frame.language );
            if ( state.frame )
            {
                document.title = state.frame.title;
                if ( state.frame.primary_color )
                {
                    Vuetify.framework.theme.themes.light.primary = state.frame.primary_color;
                }
            }
        },
        updateForm ( { commit }, form )
        {
            commit( 'setForm', form );
        },
        updateDocCheckLogin ( { commit }, docCheckLogin )
        {
            commit( 'setDocCheckLogin', docCheckLogin );
        },
        updateRoom ( { commit }, room )
        {
            commit( 'setRoom', room );
        },
    },
    getters: {
        dark: ( state ) =>
        {
            return state.frame.dark;
        },
        primaryRGB: () =>
        {
            let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec( Vuetify.framework.theme.themes.light.primary );
            return result ? [
                    parseInt( result[ 1 ], 16 ),
                    parseInt( result[ 2 ], 16 ),
                    parseInt( result[ 3 ], 16 )]
                : null;
        },
        isSingleRoomEvent: ( state ) =>
        {
            let frame = state.frame;
            return frame && ( !frame.rooms || frame.rooms.length === 1 ) && !frame.sponsors_in_extra_view && ( !frame.posters || frame.posters.length === 0 ) && !frame.display_lobby;
        },
    },
    modules: {},
} );
